import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["active", "children", "className", "fwdRef", "index", "label", "onKeyDown", "onSelect", "panelProps", "small", "startActive"];
import React, { forwardRef, useRef } from 'react';
import { buildVersionedClassNames } from '@op/opds.opux-utilities';
/**
 * A single tab, to be used within a [`<Tabs>`](#/Layout%20%26%20Structure/Tabs) container.
 *
 * As the tab label will be used as the key for matching tab list items to tabs, it must be set and it should
 * be unique within its container.
 *
 * Additional props (including `ref`) will be forwarded to the wrapping `<div>` element.
 */
export const Tab = _ref => {
  let {
      active,
      children,
      className,
      fwdRef,
      index,
      onKeyDown: _onKeyDown,
      onSelect,
      small
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const cn = buildVersionedClassNames('ds-tab', className, {
    'ds-tab--active': active,
    'ds-tab--small': small
  });
  const ref = useRef(null);
  return /*#__PURE__*/React.createElement("div", {
    className: cn,
    onKeyDown: event => _onKeyDown && _onKeyDown(event, index),
    ref: fwdRef
  }, /*#__PURE__*/React.createElement("button", _extends({}, props, {
    onClick: event => {
      event.preventDefault();
      onSelect == null || onSelect(event, index);
    },
    ref: ref,
    tabIndex: active ? 0 : -1
  }), children));
};
const Fwd = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/React.createElement(Tab, _extends({}, props, {
  fwdRef: ref
})));
Fwd.displayName = 'Tab';
export default Fwd;